import { addIndustry } from './industryService';
import { Industry } from '../models/Industry';

export const createTestIndustry = async () => {
  try {
    const testIndustry: Omit<Industry, "id"> = {
      name: "Computer Repair",
      status: "active",
      isActive: true,
      complexity: "low" as const,
      keywords: ["computers", "repair", "tech"],
      description: "Computer repair and maintenance services",
      commonIssues: ["Hardware failure", "Software issues", "Virus removal"],
      statistics: {
        averageRevenue: 75000,
        marketSize: 1000000,
        growthRate: 5,
        employeeCount: 3
      },
      risks: ["High competition", "Rapid technology changes"],
      opportunities: ["Growing demand", "Remote support services"],
      averageRevenue: 75000,
      severity: "low" as const,
      createdAt: new Date(),
      updatedAt: new Date()
    };

    const result = await addIndustry(testIndustry);
    console.log('Test industry created:', result);
    return result;
  } catch (error) {
    console.error('Error creating test industry:', error);
    throw error;
  }
}; 